module.exports = __webpack_public_path__ + "static/media/cursor.ce2560be.svg";